import type { IPageData, IPresentationData } from '../data';

// eslint-disable-next-line @typescript-eslint/ban-types
export type KeyframeOptions = {};

export type KeyframeContext = {
    idFactory: (oldId: string) => string; // 生成各个图形和页的 id
    presentation?: IPresentationData;
    page?: IPageData;
    options?: Partial<KeyframeOptions>;
};

export const DEFAULT_KEYFRAME_CONTEXT = {
    idFactory: (oldId: string) => oldId,
};
